import React, { useState, useEffect } from 'react';
import { DetailedCoin } from '../types';
import { DataTable } from './DataTable';
import './DetailsBox.css';

interface DetailsBoxProps {
  coin?: DetailedCoin;
  revealed?: boolean;
  isCountComplete?: boolean;
  isExiting?: boolean;
  countUpDurationMs?: number;
  onCountComplete?: () => void;
}

export const DetailsBox: React.FC<DetailsBoxProps> = ({
  coin,
  revealed = true,
  isCountComplete = true,
  isExiting = false,
  countUpDurationMs,
  onCountComplete
}) => {
  const [isExpanded, setIsExpanded] = useState<boolean>(false);

  // Reset expanded state whenever the coin changes
  useEffect(() => {
    setIsExpanded(false);
  }, [coin?.id]);

  const titleText = coin ? coin.name || `${coin.country} 2€ (${coin.year})` : '-';
  const descriptionText = coin ? coin.description || coin.subject || '' : '';

  let boxClass = 'stats-hidden';
  if (isExiting) {
    boxClass = 'stats-exiting';
  } else if (revealed) {
    boxClass = 'stats-revealed';
  }

  return (
    <div className={`details-box ${boxClass}`}>
      <div id="coinTitle" className="coin-title">
        {revealed ? titleText : '\u00A0'}
      </div>

      <DataTable
        coin={coin}
        revealed={revealed}
        isCountComplete={isCountComplete}
        countUpDurationMs={countUpDurationMs}
        onCountComplete={onCountComplete}
      />

      {descriptionText ? (
        <div
          id="coinDescription"
          className={`coin-description ${isExpanded ? 'expanded' : 'collapsed'}`}
          style={{
            visibility: revealed ? 'visible' : 'hidden',
            opacity: revealed ? 1 : 0,
            transition: 'opacity 0.35s ease'
          }}
          onClick={() => setIsExpanded(prev => !prev)}
          title={isExpanded ? 'Click to collapse description' : 'Click to read full description'}
        >
          {descriptionText}
        </div>
      ) : null}
    </div>
  );
};
